import { TranslationEdge, TranslationNode } from '@components/Flow';
import { NodeAuthProvider, baseClient } from '@store/index';
import { axiosErrorMiddleware } from './common';

export const executeNode = async ({
  service_id,
  node,
  plugins = [],
  edges = [],
  authentication = {
    OPENAI_API_KEY: null,
    GOOGLE_API_KEY: null,
    ANTHROPIC_API_KEY: null,
    GROK_API_KEY: null,
    GROQ_API_KEY: null,
  },
}: {
  service_id: string | undefined;
  node: TranslationNode | undefined;
  edges: TranslationEdge[];
  plugins: (TranslationNode | undefined)[];
  authentication?: NodeAuthProvider;
}): Promise<any> => {
  try {
    if (!node || !service_id) return;

    const parsedNode = {
      ...node,
      attributes: parseJSON(node.attributes, node.attributes),
      output: parseJSON(node.output, node.output),
    };

    const allPlugins = plugins.map((plugin) => ({
      ...plugin,
      attributes: parseJSON(plugin?.attributes || '', plugin?.attributes),
      output: parseJSON(plugin?.output || '', plugin?.output),
    }));

    const response = await baseClient.post(`/execute/${service_id}/test/node`, {
      node: parsedNode,
      plugins: allPlugins,
      edges,
      authentication,
    });

    if (response?.data?.detail) {
      return {
        node_id: node.node_id,
        error: JSON.stringify(response?.data?.detail),
      };
    }

    return { ...response?.data, node_id: node.node_id };
  } catch (error) {
    return axiosErrorMiddleware(error, { node_id: node?.node_id });
  }
};

const parseJSON = <T>(json: string, defaultValue: T): T => {
  try {
    return JSON.parse(json) as T;
  } catch {
    return defaultValue;
  }
};
